var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleUserLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#8f9194;}.cls-3{stroke:#8f9194;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 60,
    height: 60
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_837",
    "data-name": "Grupo 837"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_882",
    "data-name": "Rect\\xE1ngulo 882",
    className: "cls-2",
    x: 11.74,
    y: 36.22,
    width: 23.88,
    height: 5.62
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_883",
    "data-name": "Rect\\xE1ngulo 883",
    className: "cls-3",
    x: 38.43,
    y: 23.58,
    width: 9.83,
    height: 16.86
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_836",
    "data-name": "Grupo 836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_432",
    "data-name": "Trazado 432",
    className: "cls-3",
    d: "M17,36.93V18.16H46.59"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_884",
    "data-name": "Rect\\xE1ngulo 884",
    className: "cls-2",
    x: 38.43,
    y: 36.22,
    width: 9.83,
    height: 4.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleUserLogs);
export default __webpack_public_path__ + "static/media/icon_module_user_logs.4e1cdfbe7ab4e982898fad17c66c4fc1.svg";
export { ForwardRef as ReactComponent };